<app-component-header></app-component-header>
<div class="flex flex-column">
  <div class="flex flex-column align-items-center justify-content-center pt-3">
    <div class="flex">
      <div class="flex align-items-center p-3">
        <label for="plate-search" class="ml-2">Plate Search</label>
        <p-radioButton class="ml-2" name="plate-search" [(ngModel)]="searchSelectedValue" inputId="plate-search" value="Plate" (onClick)="selectedSearchView($event)"></p-radioButton>
      </div>
      <div class="flex align items-center p-3">
        <label for="sample-search" class="ml-2">Sample Search</label>
        <p-radioButton class="ml-2" name="sample-search" [(ngModel)]="searchSelectedValue" inputId="sample-search" value="Sample" (onClick)="selectedSearchView($event)"></p-radioButton>
      </div>
    </div>
    <div class="flex flex-column align-items-start md:flex-row lg:flex-row">
      <div *ngIf="searchSelectedValue === 'Sample'" class="flex justify-content-center align-items-center">
        <p-dropdown class="p-2" [(ngModel)]="selectedSampleSearchType" (onChange)="sampleSearchTypeChange($event)" [options]="sampleSearchOptions" placeholder="Search type" [autoDisplayFirst]="false"></p-dropdown>
      </div>
      <div class="flex align-items-center">
        <span class="p-input p-2">
          <input type="text" pInputText #commonInput (keyup.enter)="startSearching(commonInput.value)" [placeholder]="searchPlaceHolderMessage"/>
        </span>
        <div class="bg-primary p-3 search-button cursor-pointer" (click)="startSearching(commonInput.value)">
          <i class="pi pi-search"></i>
        </div>
      </div>
    </div>
  </div>
  <div>
    <div *ngIf="searchSelectedValue === 'Sample'">
      <app-sample-search *ngIf="commonInput !== ''" [selectedLabID]="selectedLabID" [searchType]="selectedSampleSearchType" [puid]="puid" [searchTypeValue]="searchInput" (onDownloadExcelClick)="downloadExcel($event)"></app-sample-search>
    </div>
    <div *ngIf="searchSelectedValue === 'Plate'">
      <app-plate-search *ngIf="commonInput !== ''" [isSuperUserOrAdmin]="isSuperUserOrAdmin" [selectedLabID]="selectedLabID" [searchInput]="searchInput" [puid]="puid" (onDownloadExcelClick)="downloadExcel($event)"></app-plate-search>
    </div>
  </div>
</div>
